import { useStrings } from "@1js/localization-components";
import { Tab } from "@fluentui/react-components";
import React from "react";
import { GroupPromptsLabel } from "./PromptTab.strings";

type GroupTabProps = {
  setTarget?: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
};
export const GroupTab: React.FC<GroupTabProps> = ({ setTarget }) => {
  const localizations = useStrings({
    GroupPromptsLabel,
  });

  return (
    <Tab
      aria-label={localizations.GroupPromptsLabel()}
      value={"GroupPrompts"}
      data-testid="bookmarked-prompts-tab"
      ref={setTarget}
    >
      {localizations.GroupPromptsLabel()}
    </Tab>
  );
};
